import { connect } from 'react-redux';
import { subscriptions } from 'app/selectors/subscriptions';
import MachineAccessField from 'app/components/settings/machine-access-field';

const mapStateToProps = state => ({
  isSubscriber: subscriptions.isSubscriber(state),
});

const mapDispatchToProps = () => ({
});

const MachineAccessFieldContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MachineAccessField);

export default MachineAccessFieldContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/machine-access-field.js